<loading-animation size="large" *ngIf="!isReady"></loading-animation>

<section class="control-setpoint cl-device-grouping" [formGroup]="setpointEditorForm" *ngIf="isReady && inputs"
         [ngClass]="{'dialog': isDialog}">

    <dl-rtu-dialog-buttons *ngIf="!isDialog"
                        [override]="override"
                        [currentSetpoint]="currentSetpoint"
                        [setpointEditorForm]="setpointEditorForm"
                        (saveEmitter)="save()"
                        (cancelEmitter)="cancel()"
    >
    </dl-rtu-dialog-buttons>
    <!-- Buttons for Thermostat View -->
    <cas-button btnClass="md-accent md-raised" *ngIf="override && (allowApplyToArea || allowApplyToSite)"
                (clickAction)="toggleCopyToVisible()" btnText="Copy To"></cas-button>
    <cas-button btnClass="md-accent md-raised" *ngIf="override" (clickAction)="overrideSchedule()"
                [disabled]="!setpointEditorForm.dirty || setpointEditorForm.invalid"
                btnText="Override Schedule"></cas-button>

    <div *ngIf="copyToVisible">
        <dl-device-input *ngIf="allowApplyToArea" [deviceInfo]="{}" [deviceInput]="inputs.applyToArea"
                      [deviceInputForm]="setpointEditorForm"></dl-device-input>
        <dl-device-input *ngIf="allowApplyToSite" [deviceInfo]="{}" [deviceInput]="inputs.applyToSite"
                      [deviceInputForm]="setpointEditorForm"></dl-device-input>
    </div>

    <dl-device-input [deviceInfo]="{}" [deviceInput]="inputs.controlMode"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="showOccupied()" [deviceInfo]="{}" [deviceInput]="inputs.occupied"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="showBlower()" [deviceInfo]="{}" [deviceInput]="inputs.blowerMode"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="showUseExternalEfficiencySetpoints()" [deviceInfo]="{}"
                  [deviceInput]="inputs.useExternalEfficiencySetpoints"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="showCooling()" [deviceInfo]="{}" [deviceInput]="inputs.coolingTemp"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="showHeating()" [deviceInfo]="{}" [deviceInput]="inputs.heatingTemp"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-device-input *ngIf="override" [deviceInfo]="{}" [deviceInput]="inputs.overrideMinutes"
                  [deviceInputForm]="setpointEditorForm"></dl-device-input>

    <dl-rtu-dialog-buttons *ngIf="isDialog"
                        [override]="override"
                        [currentSetpoint]="currentSetpoint"
                        [setpointEditorForm]="setpointEditorForm"
                        (saveEmitter)="save()"
                        (cancelEmitter)="cancel()"></dl-rtu-dialog-buttons>
</section>
